import React, { useContext } from 'react';
import { Modal, Button, Select } from 'semantic-ui-react';
import {
  weekdays,
  comunidadProcess,
  eventSlugnameTrim,
  seminary,
  isSeminarioKind,
  GROUP_KINDS,
  chPerm,
  searchSelectProps,
} from 'src/components/helpers';
import NewGroupForm from './registration/newGroupForm';
import groupService from 'src/services/api/groupService';
import Swal from 'sweetalert2';
import CoupleGroupRegistration from './registration/groupRegistration';
import ChangeLeadersModal from './changeLeadersModal';
import { withRouter } from 'react-router-dom';
import queryString from 'query-string';
import { RegistrationForm } from 'src/assets/styles/components/Registration';
import { ListsContext } from 'src/services/contextProviders/lists/listsContext';
import {
  useRecaptchaToken,
  isCaptchaRequired,
  RECAPTCHA_SECURITY_ERROR,
} from 'src/components/helpers/recaptchaUtils';

export const coupleKindOfGroupByCategory = (groupOrKind = '') => {
  const kind = typeof groupOrKind === 'object' ? groupOrKind?.kind : groupOrKind;
  return kind || GROUP_KINDS.LIDERES;
};

const ViewCoupleGroup = (props) => {
  const { editing, editingInputs, getInfo, open, setOpen } = props;
  const [inputs, setInputs] = React.useState({});
  const [errorInputs, set_errorInputs] = React.useState({});
  const [loading, set_loading] = React.useState(false);
  const [Step, setStep] = React.useState('create');
  const { groupCategories } = useContext(ListsContext);
  const getCaptchaToken = useRecaptchaToken('edit_couple_group');

  React.useEffect(() => {
    setInputs({ ...(editingInputs || {}) });
  }, [editingInputs]);

  const isCouples =
    (inputs.activityName && inputs.activityName.includes('Parejas')) || inputs.coupleleadered;

  let query = props.location.search;
  let parsedQueryString = queryString.parse(query);

  const params = props.match.params;

  let kindgroup =
    inputs.kindgroup ||
    params.kind ||
    parsedQueryString.kindgroup ||
    coupleKindOfGroupByCategory(inputs.kind || inputs);

  const categoriesgrouplist = kindgroup === 'Grupo_Seminario' ? seminary : groupCategories;

  const verifyForm = () => {
    let mandatoryInputs = ['activityName', 'time'];
    const isSeminario = isSeminarioKind(kindgroup);

    if (!isSeminario) {
      mandatoryInputs = [...mandatoryInputs, 'groupName'];
      if (!inputs.femaleCrecerlevel && !inputs.maleCrecerlevel) {
        mandatoryInputs = [...mandatoryInputs, 'femaleCrecerlevel', 'maleCrecerlevel'];
      }
    }

    if (isSeminario) {
      mandatoryInputs = [...mandatoryInputs, 'maxCapacity'];
    }

    if (!inputs.online) {
      mandatoryInputs = [...mandatoryInputs, 'address'];
    }

    let inputsWithErrors = {};

    inputsWithErrors = {
      ...inputsWithErrors,
      dayOfWeek: typeof inputs['dayOfWeek'] !== 'number',
    };

    mandatoryInputs.forEach((input) => {
      inputsWithErrors = {
        ...inputsWithErrors,
        [input]: !inputs[input],
      };
    });

    set_errorInputs(inputsWithErrors);
    return Object.values(inputsWithErrors).includes(true);
  };

  React.useEffect(() => {
    if (Step === 'send') {
      send();
    }
  }, [Step]);

  const deleteGroup = () => {
    Swal.fire({
      title: `¿Seguro que desea eliminar el grupo?`,
      showCancelButton: true,
      confirmButtonText: 'Si, Eliminar',
      cancelButtonText: 'Volver',
    }).then((result) => {
      if (result.value) {
        setInputs({ ...inputs, deleted: 'adminDelete' });
      }
    });
  };

  React.useEffect(() => {
    if (inputs.deleted) {
      send();
    }
  }, [inputs.deleted]);

  const onErrorStep = () => setStep(isCouples ? 'person1 person2' : 'person1');

  const send = async (e) => {
    if (e) e.preventDefault();
    if (verifyForm()) return onErrorStep();

    if (
      isCouples &&
      inputs.person1 &&
      inputs.person2 &&
      inputs.person1.gender === inputs.person2.gender
    )
      return Swal.fire('Los lideres deben ser de genero diferente.');

    set_loading(true);
    const payload = {
      ...inputs,
      kindgroup,
      kind: kindgroup,
    };
    if (editing) {
      const captchaRequired = isCaptchaRequired();
      const captcha = await getCaptchaToken({ skip: !captchaRequired });
      if (captchaRequired && !captcha) {
        set_loading(false);
        onErrorStep();
        Swal.fire(RECAPTCHA_SECURITY_ERROR);
        return;
      }

      groupService
        .editGroup({
          ...payload,
          ...(captchaRequired ? { captcha } : {}),
        })
        .then((response) => {
          if (response.data.success) {
            if (response.data) Swal.fire(response.data.message);
            setOpen(false);
            if (parsedQueryString.event) {
              window.location.replace(
                `/servicio/reservacion?event=${parsedQueryString.event}&id=event&phone=${parsedQueryString.phone}&identification=${parsedQueryString.identification}`
              );
            } else {
              getInfo();
            }
          } else {
            if (response.data) Swal.fire(response.data.message);
            onErrorStep();
          }
          set_loading(false);
        })
        .catch((error) => {
          if (error.response) Swal.fire(error.response.data.message);
          onErrorStep();
          set_loading(false);
        });
    } else {
      groupService
        .createGroup(payload)
        .then((response) => {
          if (response.data.success) {
            getInfo();
            setOpen(false);
            if (response.data) Swal.fire(response.data.message);
          } else {
            if (response.data) Swal.fire(response.data.message);
            onErrorStep();
          }
          set_loading(false);
        })
        .catch((error) => {
          if (error.response) Swal.fire(error.response.data.message);
          onErrorStep();
          set_loading(false);
        });
    }
  };

  const handleInputs = (event) => {
    let value = event.target.value;
    let name = event.target.name;
    setInputs({ ...inputs, [name]: value });
  };

  const handleCheckers = (name) => setInputs({ ...inputs, [name]: !inputs[name] });

  const selectHandle = (a, { value, name }) => {
    if (name === 'kindgroup') {
      setInputs({
        ...inputs,
        kindgroup: value,
        kind: value,
        activityName: '',
      });
      return;
    }
    setInputs({ ...inputs, [name]: value });
  };

  const formSelect = ({
    name,
    label,
    value,
    disabled = false,
    options = [],
    handler = selectHandle,
  }) => {
    return (
      <Select
        placeholder={label}
        disabled={disabled}
        className={`Registration__input Registration__input-${name} ${
          errorInputs[name] ? 'error' : ''
        }`}
        {...searchSelectProps({
          name,
          value,
          handler,
          options: options?.map((opt) => {
            return { key: opt, value: opt, text: eventSlugnameTrim(opt) };
          }),
        })}
      />
    );
  };

  return (
    <>
      <Button primary={parsedQueryString.event} onClick={() => setOpen(true)}>
        {editing ? 'Ver/Editar' : 'Crear'} Grupo
      </Button>
      {open && (
        <Modal onClose={() => setOpen(false)} closeIcon open>
          <Modal.Header>{editing ? 'Ver/Editar' : 'Crear'} grupo</Modal.Header>
          <RegistrationForm onSubmit={(e) => send(e)}>
            {editing && (
              <>
                <h3>Líder{Boolean(isCouples) && 'es'}</h3>
                {!!inputs.maleLeader && (
                  <p>
                    <span style={{ fontWeight: 'bolder' }}>
                      {inputs.maleLeader.name} {inputs.maleLeader.lastName}
                    </span>{' '}
                    <span>{inputs.maleLeader.identification}</span>
                  </p>
                )}
                {!!inputs.femaleLeader && (
                  <p>
                    <span style={{ fontWeight: 'bolder' }}>
                      {inputs.femaleLeader.name} {inputs.femaleLeader.lastName}
                    </span>{' '}
                    <span>{inputs.femaleLeader.identification}</span>
                  </p>
                )}
              </>
            )}
            <NewGroupForm
              inputs={inputs}
              editing={editing}
              handleInputs={handleInputs}
              selectHandle={selectHandle}
              formSelect={formSelect}
              setInputs={setInputs}
              categoriesgrouplist={categoriesgrouplist}
              kindgroup={kindgroup}
              comunidadProcess={comunidadProcess}
              weekdays={weekdays}
              handleCheckers={handleCheckers}
              loading={loading}
              errorInputs={errorInputs}
              isCouples={isCouples}
            />
            {!editing && (
              <>
                <CoupleGroupRegistration
                  inputs={inputs}
                  setInputs={setInputs}
                  loading={loading}
                  setStep={setStep}
                  person="person1"
                  next={isCouples ? 'person1 person2' : 'send'}
                  strictNext
                  leaderView
                />

                {isCouples && Step.includes('person2') && (
                  <CoupleGroupRegistration
                    inputs={inputs}
                    loading={loading}
                    setInputs={setInputs}
                    setStep={setStep}
                    person="person2"
                    next={'send'}
                    strictNext
                    leaderView
                  />
                )}
              </>
            )}
          </RegistrationForm>
          <div style={{ padding: '20px 0', textAlign: 'center' }}>
            {editing && (
              <>
                {chPerm(['groups']) && (
                  <ChangeLeadersModal getInfo={getInfo} isCouples={isCouples} groupId={inputs.id} />
                )}
                {localStorage.getItem('userToken') && (
                  <Button
                    basic
                    color="red"
                    content="Red"
                    loading={loading}
                    onClick={(e) => deleteGroup(e)}
                  >
                    Eliminar
                  </Button>
                )}
                <Button secondary loading={loading} onClick={(e) => send(e)}>
                  Guardar{parsedQueryString.event && ' y continuar registro'}
                </Button>
              </>
            )}
          </div>
        </Modal>
      )}
    </>
  );
};

ViewCoupleGroup.defaultProps = {
  kindgroup: [],
};

export default withRouter(ViewCoupleGroup);
